import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnInit,
  TemplateRef,
  ViewChild,
  ChangeDetectionStrategy
} from '@angular/core';
import { ZalamoDialogService } from 'ZalamoLibrary/src/lib/ui/zalamo-dialog/zalamo-dialog.service';

@Component({
    selector: 'lib-wallart',
    templateUrl: './wallart.component.html',
    styleUrls: ['./wallart.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class WallartComponent implements OnInit {
  image1 = '';
  @ViewChild('img1', { static: true }) img: ElementRef<HTMLImageElement>;
  @ViewChild('img2', { static: true }) img2: ElementRef<HTMLImageElement>;
  @ViewChild('menu', { static: true }) menu: TemplateRef<any>;
  r = 0.01;
  b = 1;
  g = 1;
  a = 1;

  get matrix() {
    return `0 0 0 0 ${this.r} 
               0 0 0 0 ${this.g} 
               0 0 0 0 ${this.b} 
               0 0 0 1 0`;
  }

  private _color;

  get color() {
    return this._color;
  }

  set color(color: string) {
    console.log(color);
    if (color.substr(0, 4) === 'rgba') {
      const colors = color
        .substring(4)
        .substring(1, color.substring(4).length - 1)
        .split(',');
      console.log(colors);
      this.r = this.parseValue(parseInt(colors[0]));
      this.g = this.parseValue(parseInt(colors[1]));
      this.b = this.parseValue(parseInt(colors[2]));
      this.a = Number(colors[3]);
      console.log(colors[3], this.a);
    } else {
      const colors = color
        .substring(3)
        .substring(1, color.substring(3).length - 1)
        .split(',');
      console.log(colors);
      this.r = this.parseValue(parseInt(colors[0]));
      this.g = this.parseValue(parseInt(colors[1]));
      this.b = this.parseValue(parseInt(colors[2]));
    }
    document.body
      .querySelector('feColorMatrix')
      .setAttribute('values', this.matrix);
    this._color = color;
  }

  set opacity(opacity) {}

  constructor(
    private zalamoDialogService: ZalamoDialogService,
    private cd: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.img.nativeElement.src = 'https://zalamo.com/samples/wed1.jpg';
  }

  showMenu() {
    this.zalamoDialogService.openRight(this.menu);
  }

  uploadImage(image, event) {
    switch (image) {
      case 1:
        this.img.nativeElement.src = URL.createObjectURL(event.target.files[0]);
        break;
      case 2:
        this.img2.nativeElement.src = URL.createObjectURL(
          event.target.files[0]
        );
        break;
    }
  }

  parseValue(val) {
    return Math.round((val / 255) * 100) / 100;
  }
}
